/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MiniOrganization } from './MiniOrganization';
import {
    MiniOrganizationFromJSON,
    MiniOrganizationFromJSONTyped,
    MiniOrganizationToJSON,
    MiniOrganizationToJSONTyped,
} from './MiniOrganization';
import type { JoinRequestCreatedResponse } from './JoinRequestCreatedResponse';
import {
    JoinRequestCreatedResponseFromJSON,
    JoinRequestCreatedResponseFromJSONTyped,
    JoinRequestCreatedResponseToJSON,
    JoinRequestCreatedResponseToJSONTyped,
} from './JoinRequestCreatedResponse';

/**
 * 
 * @export
 * @interface UpdateOrganizationResponse
 */
export interface UpdateOrganizationResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationResponse
     */
    status: string;
    /**
     * 
     * @type {MiniOrganization}
     * @memberof UpdateOrganizationResponse
     */
    organization?: MiniOrganization;
    /**
     * 
     * @type {JoinRequestCreatedResponse}
     * @memberof UpdateOrganizationResponse
     */
    join_request?: JoinRequestCreatedResponse;
}

/**
 * Check if a given object implements the UpdateOrganizationResponse interface.
 */
export function instanceOfUpdateOrganizationResponse(value: object): value is UpdateOrganizationResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateOrganizationResponseFromJSON(json: any): UpdateOrganizationResponse {
    return UpdateOrganizationResponseFromJSONTyped(json, false);
}

export function UpdateOrganizationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrganizationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'organization': json['organization'] == null ? undefined : MiniOrganizationFromJSON(json['organization']),
        'join_request': json['join_request'] == null ? undefined : JoinRequestCreatedResponseFromJSON(json['join_request']),
    };
}

export function UpdateOrganizationResponseToJSON(json: any): UpdateOrganizationResponse {
    return UpdateOrganizationResponseToJSONTyped(json, false);
}

export function UpdateOrganizationResponseToJSONTyped(value?: UpdateOrganizationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'organization': MiniOrganizationToJSON(value['organization']),
        'join_request': JoinRequestCreatedResponseToJSON(value['join_request']),
    };
}

